module.exports = __webpack_public_path__ + "static/img/16.18c1eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/companyLogo/16.png
// module id = qGeI
// module chunks = 1